import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const countryService = {
  async getDropdownAsync() {
    const response = await apiClient.get(endPoints.country.dropdown);
    return response.data;
  },
};
